export const HISTORICAL_ENTRY_FIELDS = {
  metricName: 'Metric',
  period: 'Period',
  bestCase: 'Best case',
  worstCase: 'Worst case',
  result: 'Result',
  bonusShare: 'Monthly bonus share',
};
